const mutations = {
  SetPackagingSlipConfigurations(state, configurations) {
    state.configurations = configurations;
  },
  UpdatePackagingSlipConfiguration(state, configuration) {
    if(!configuration) return;
    if (state.configurations.length > 1) {
      const index = state.configurations.findIndex(x => x.id === configuration.id)
      if (configuration.active){
        state.configurations.filter(x => x.id !== configuration.id).forEach(element => {
          element.active = false;
        });
      }
      state.configurations[index] = configuration;
    } else {
      state.configurations[0] = configuration;
    }
  },
  DeletePackagingSlipConfiguration(state, configuration) {
    state.configurations = state.configurations.filter(x => x.id !== configuration.id)
  },
}

export default mutations;